const CARDS = [
  {
    id: 'cd1',
    title: '某艺人深夜发文引全网猜测，工作室火速回应',
    desc: '凌晨三点的一条微博引发千万转发，内容模棱两可。粉丝连夜分析文字暗号，吃瓜群众各显神通解码…',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20smartphone%20screen%20with%20social%20media%20post%20in%20dark%20night%20setting%2C%20warm%20glowing%20screen%20light%2C%20mysterious%20atmosphere%2C%20modern%20minimalist%20editorial%20style%2C%20coral%20and%20amber%20accents%2C%20no%20text%2C%20clean%20composition&width=800&height=500&seq=cards-item-01&orientation=landscape',
    tag: '娱乐',
    time: '3 小时前',
    hot: '9.6万',
  },
  {
    id: 'cd2',
    title: '百万粉丝博主被扒黑历史，账号连夜清空',
    desc: '某知识类博主因早年言论被网友大规模考古，争议内容迅速扩散。该博主已将所有社交账号设为私密。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20digital%20profile%20being%20erased%20with%20dramatic%20warm%20lighting%2C%20floating%20document%20shapes%2C%20modern%20minimalist%20clean%20design%2C%20editorial%20news%20aesthetic%2C%20amber%20and%20coral%20gradients%2C%20no%20text&width=800&height=500&seq=cards-item-02&orientation=landscape',
    tag: '网红',
    time: '5 小时前',
    hot: '7.8万',
  },
  {
    id: 'cd3',
    title: '某热播综艺录制现场突发状况，导演组紧急叫停',
    desc: '据现场观众爆料，某热门综艺新一期录制中发生意外冲突，参演嘉宾当场离场。节目组至今未对此事做出正式说明。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20TV%20studio%20set%20with%20dramatic%20warm%20red%20alert%20lighting%2C%20abstract%20shapes%20suggesting%20chaos%2C%20modern%20minimalist%20editorial%20design%2C%20clean%20composition%2C%20no%20text&width=800&height=500&seq=cards-item-03&orientation=landscape',
    tag: '综艺',
    time: '7 小时前',
    hot: '6.5万',
  },
  {
    id: 'cd4',
    title: '国际品牌代言人风波：官宣两小时又删除',
    desc: '某国际大牌在官宣中国区代言人后突然删除所有相关物料，引发品牌粉丝与艺人粉丝的激烈讨论，原因成谜。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20modern%20illustration%20of%20luxury%20brand%20billboard%20being%20removed%2C%20warm%20golden%20and%20coral%20lighting%2C%20editorial%20fashion%20magazine%20style%2C%20clean%20minimalist%20composition%2C%20dramatic%20yet%20elegant%2C%20no%20text&width=800&height=500&seq=cards-item-04&orientation=landscape',
    tag: '品牌',
    time: '9 小时前',
    hot: '5.3万',
  },
  {
    id: 'cd5',
    title: '校园热点：某高校食堂事件登上全国热搜',
    desc: '一则高校食堂的争议视频在短视频平台爆火，播放量破亿。校方连夜发布情况说明，但网友并不买账。',
    image: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20university%20campus%20with%20social%20media%20trending%20visual%20elements%2C%20warm%20evening%20light%2C%20modern%20editorial%20style%2C%20abstract%20data%20visualization%2C%20coral%20and%20amber%20accents%2C%20clean%20composition%2C%20no%20text&width=800&height=500&seq=cards-item-05&orientation=landscape',
    tag: '社会',
    time: '12 小时前',
    hot: '4.9万',
  },
];

export default function Cards() {
  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">
          热门事件
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10">
          最新最热的网络热门事件一览
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CARDS.map((card) => (
            <a
              key={card.id}
              href="#updates"
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-200 transition-all cursor-pointer group flex flex-col"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4 flex-1 flex flex-col">
                <div className="flex items-center gap-2 mb-2">
                  <span className="bg-primary-100 text-primary-700 text-xs font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
                    {card.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{card.time}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                  {card.title}
                </h3>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2 flex-1">
                  {card.desc}
                </p>
                <div className="flex items-center gap-1 text-xs text-accent-500 mt-3">
                  <i className="ri-fire-line"></i>
                  <span className="font-medium">{card.hot}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}